import { Box, Button, CircularProgress, Container, Grid2, List, ListItem, ListItemText, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectState } from "./AdministratorOptionsPageSlice";
import { RefreshOutlined, SummarizeOutlined, SwapHorizOutlined, UploadFileOutlined, UploadOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export function AdministratorOptionsPage() {

    const theme = useTheme();
    const lessThanSm = useMediaQuery(theme.breakpoints.down("sm"));
    const dispatch = useAppDispatch();
    const state = useAppSelector(selectState)
    const navigate = useNavigate();
    useEffect(() => {

    }, []);

    return (
        <Container maxWidth="sm" disableGutters={lessThanSm}>
            <Box
                sx={{
                    minHeight: "100vh",
                    alignItems: "start",
                }}
            >
                <Grid2
                    container
                    spacing={2}
                    direction="column"
                    sx={{ mt: 2 }}
                    columns={{ xs: 6, sm: 6, md: 12 }}
                >
                    <Button
                        component="label"
                        variant="contained"
                        startIcon={<SummarizeOutlined sx={{ color: "#FFFFFF" }} />}
                        onClick={(e: any) => {
                            navigate("/ReportingPage");
                        }}
                    >
                        <Typography variant="h5">Reports</Typography>
                    </Button>

                    <Button
                        component="label"
                        variant="contained"
                        startIcon={<UploadOutlined sx={{ color: "#FFFFFF" }} />}
                        onClick={(e: any) => {
                            navigate("/AdministratorPage");
                        }}
                    >
                        <Typography variant="h5">Imports</Typography>
                    </Button>

                    <Button
                        component="label"
                        variant="contained"
                        startIcon={<SwapHorizOutlined sx={{ color: "#FFFFFF" }} />}
                        onClick={(e: any) => {
                            navigate("/KeyTransferPage");
                        }}
                    >
                        <Typography variant="h5">Transfer Keys</Typography>
                    </Button>
                </Grid2>
            </Box>
        </Container>
    );
}